import { Injectable } from "@angular/core";
import { IPaymentGatewayProvider } from "./payment-gateway-provider";
import { BehaviorSubject, Observable } from "rxjs";
import { ExternalPaymentModel, PaymentModel, PaymentsModel, PaymentStatusModel, PaymentVoucher } from "../../models/payment-models";
import { PaymentAddressView } from "../../models/payment-models/payment-address.model";
import { PaymentConstant } from 'src/app/modules/order/shared';
import { PaymentService } from "../payment-services";
import { GATEWAY_PAYMENT_STATUS } from "./payment-gateway-constant";
import { ExternalPaymentConstantCode } from "../../constants/extenral-payment-constants";



@Injectable({
    providedIn: 'root'
})
export class GoCardlessGatewayService implements IPaymentGatewayProvider {
    public readonly PAYMENT_CONSTANT = PaymentConstant;
    private readonly PAYMENT_PARAM_NAME = "paymentId";
    private readonly PROCESS_PAYMENT_PARAMS = `scrollbars=no,
        resizable=yes,
        status=no,
        location=no,
        toolbar=no,
        menubar=no,
        width=680,
        height=900,
        left=-1000,
        top=-1000`;

    constructor(private paymentService: PaymentService) {

    }
    
    processPayment(payment: ExternalPaymentModel): Observable<PaymentStatusModel> {
        this.setResponseResult(ExternalPaymentConstantCode.CheckKey , new Date().toISOString());

        const parsedUrl = new URL(window.location.href);
        const baseUrl = parsedUrl.origin;
        const observable$ = new BehaviorSubject<PaymentStatusModel>(null);
        const successQueryString = this.createSuccessQueryString(payment);
        const initialPayment = this.createInitialPayment(
            payment.recordLocator,
            payment.orderId,
            payment.amount.currencyCode,
            payment.amount.value,
            payment.organisationCode,
            payment.payments,
            payment.paymentVoucher,
            payment.paymentAddress,
            `${baseUrl}/payment/external`,
            successQueryString,
            payment.cancelQueryString,
            payment.errorQueryString
        );
        
        let winRef;
        if (payment.payments.formOfPaymentTypeCode == this.PAYMENT_CONSTANT.eft &&
            payment.payments.formOfPaymentCode == this.PAYMENT_CONSTANT.eft
        ) {
            winRef = window.open('', '_blank', this.PROCESS_PAYMENT_PARAMS);
            if (!winRef?.document) {
                const response = { status: GATEWAY_PAYMENT_STATUS.ERROR } as PaymentStatusModel;
                observable$.next(response);
                return;
            }
            winRef.document.write('Loading ...');
        }

        this.paymentService.processPayment(initialPayment)
            .subscribe((response: PaymentStatusModel) => {
                if (payment.payments.formOfPaymentTypeCode == this.PAYMENT_CONSTANT.eft) {
                    const externalPaymentUrl = response?.data?.redirectUrl;
                    if (externalPaymentUrl) {
                        const paymentId = response.data.paymentId;
                        winRef.location.href = `${externalPaymentUrl}`;

                        let loop = setInterval(() => {
                            if (winRef.closed) {
                                clearInterval(loop);
                                response.status = this.getResponseResult(paymentId);
                                this.clearResponseResult(paymentId);
                                observable$.next(response);
                            }
                        }, 500);
                    }
                } else {
                    if (!response.status) {
                        if (response.paymentStatus === PaymentConstant.paid) {
                            response.status = GATEWAY_PAYMENT_STATUS.SUCCESS;
                        } else if (!winRef) {
                            response.status = GATEWAY_PAYMENT_STATUS.INPROCESS;
                        }
                    }
                    observable$.next(response);
                }
            }, ((e) => {
                winRef.close();
                const response = { status: GATEWAY_PAYMENT_STATUS.ERROR } as PaymentStatusModel;
                observable$.next(response);
            }));
        return observable$;
    }

    private createSuccessQueryString(payment: ExternalPaymentModel) {
        let query = `${this.PAYMENT_PARAM_NAME}=${payment.payments.paymentId}`;
        if (payment.successQueryString) query += `&${payment.successQueryString}`
        return query;
    }

    private _responseParam: URLSearchParams;
    private _responseStatus: string;
    private readonly STATUS: string = "status";
    handlePaymentPageResponse(): void {
        const parsedUrl = new URL(window.location.href);
        const params = new URLSearchParams(parsedUrl.search);
        const paymentId = params.get(this.PAYMENT_PARAM_NAME);
        
        this._responseParam = params;
        this._responseStatus = params.get(this.STATUS);
        this.setResponseResult(paymentId, this._responseStatus);
    }
    private setResponseResult(key: string, value: string): void {
        localStorage.setItem(key, value);
    }

    getResponseStatus(): string {
        return this._responseStatus;
    }
    getResponseParam(key: string): string {
        if (!this._responseParam) return null;
        return this._responseParam.get(key);
    }
    resetResponseStatus(): void {
        this._responseStatus = null;
    }
    private getResponseResult(key: string): string {
        return localStorage.getItem(key);
    }
    private clearResponseResult(key: string): void {
        localStorage.removeItem(key);
    }

    private createInitialPayment(recordLocator: string,
        orderId: string,
        paymentCurrency: string,
        paymentAmount: number,
        organisationCode: string,
        payments: PaymentsModel,
        paymentVoucher: PaymentVoucher,
        paymentAddress: PaymentAddressView,
        redirectUrl: string,
        successQueryString: string,
        cancelQueryString: string,
        errorQueryString: string,
        ): PaymentModel {

        let fopParam = `fopt=${payments.formOfPaymentTypeCode}&fop=${payments.formOfPaymentCode}`;
        if (payments.topUpPaymentFlag) fopParam += '&topup=true';
        return {
            context: {
                language: "en",
                currencyCode: "EUR",
                organisationCode: organisationCode,
                organisationId: null
            },
            orderNumber: recordLocator,
            orderId: orderId,
            formOfPayments: null,
            total: {
                sales: {
                    currencyCode: paymentCurrency,
                    amount: paymentAmount
                }
            },
            payments: [payments],
            paymentVoucher: paymentVoucher,
            redirect: {
                successUrl: redirectUrl + `?${this.STATUS}=${GATEWAY_PAYMENT_STATUS.SUCCESS}&${successQueryString}&${fopParam}`,
                cancelUrl: redirectUrl + `?${this.STATUS}=${GATEWAY_PAYMENT_STATUS.CANCEL}&${cancelQueryString}&${fopParam}`,
                errorUrl: redirectUrl + `?${this.STATUS}=${GATEWAY_PAYMENT_STATUS.ERROR}&${errorQueryString}&${fopParam}`
            },
            paymentAddress: paymentAddress
        };
    }
}